module.exports = __webpack_public_path__ + "img/10.a7019419.png";